import {authenticationErrorState} from "../../utils/types";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState: authenticationErrorState = {
    error: null,
}

export const authenticationErrorSlice = createSlice({
    name: 'authenticationError',
    initialState,
    reducers: {
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export const {
    setError,
} = authenticationErrorSlice.actions;

export default authenticationErrorSlice.reducer;